import { useEffect, useState } from 'react';
import type { GpsInput } from '@eombor/contracts';

/**
 * Brauzerdan olinadigan KOORDINATA.
 *
 * Ikki narsani bilib turish kerak, aks holda "nega bo'sh?" degan savol
 * javobsiz qoladi:
 *
 * 1. **Brauzer buni faqat XAVFSIZ KONTEKSTDA beradi** — ya'ni `https://`
 *    yoki `localhost`. Tizim ichki tarmoqda `http://` va IP bilan ochilsa,
 *    bu manba umuman ishlamaydi va xato ham ko'rinmaydi: chaqiruv
 *    shunchaki xato ilmog'iga tushadi. Shu sababli u YAGONA manba
 *    bo'lmasligi kerak — server koordinatani rasmning EXIF idan ham
 *    oladi.
 * 2. **Ombor ichida signal bo'lmasligi oddiy hol** (metall tokchalar,
 *    yerto'la). Javob kutilmaydi va xato oqimni to'xtatmaydi.
 *
 * Natija `null` bo'lishi normal holat, xato emas.
 */
export const useGeolocation = (enabled: boolean): GpsInput | null => {
  const [gps, setGps] = useState<GpsInput | null>(null);

  useEffect(() => {
    if (!enabled || gps !== null || typeof navigator.geolocation === 'undefined') return;
    navigator.geolocation.getCurrentPosition(
      (position) => setGps({ lat: position.coords.latitude, lng: position.coords.longitude }),
      () => {
        // Rad etildi, signal yo'q yoki kontekst xavfsiz emas — koordinata
        // shunchaki bo'lmaydi.
      },
      { timeout: 5000, maximumAge: 60_000 },
    );
  }, [enabled, gps]);

  return gps;
};
